import axios from 'axios';
import config from 'config/config';
import { dispatch, getState } from 'config/store';
import { setSnackBarObj } from 'reducers/Alerts';
import { getItemFromLocalStorage, removeLocalStorage, setItemInLocalStorage } from './helpers';

export default {
  initialize: () => {
    axios.defaults.baseURL = config.backendUrl;
    // Request Interceptor. All Request pass from here
    axios.interceptors.request.use(
      axiosConfig => {
        const authToken = getItemFromLocalStorage('auth_token', null, false);
        const maintenanceBypassToken = getState().User.maintenanceBypassToken;
        if (authToken) {
          axiosConfig.headers['Authorization'] = `Bearer ${authToken}`;
        }
        if (maintenanceBypassToken) {
          axiosConfig.headers[config.maintenanceByPassKey] = maintenanceBypassToken;
        }
        axiosConfig.headers['Content-Type'] = 'application/json';
        return axiosConfig;
      },
      error => {
        Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      response => response,
      error => {
        // Handle different error scenarios
        if (error?.response?.status === 401) {
          // Unauthorized user, token expired, etc.
          removeLocalStorage();
          const path = window.location.pathname;
          if (path !== '/PagesRegister' && path !== '/' && path !== '/ImpersonateLogin') {
            setItemInLocalStorage('redirect_url', window.location);
          }
          if (path !== '/PagesRegister') {
            window.location.href = '/PagesRegister';
          }
        } else if (error.message === 'Network Error' && !error.response) {
          dispatch(
            setSnackBarObj({
              message: `It seems like you're currently offline. Please check your internet connection.`,
              severity: 'error',
            })
          );
        } else {
          if (!(axios.isCancel(error) || error.code === 'ECONNABORTED')) {
            console.log('error', error.message);
            dispatch(setSnackBarObj({ severity: 'error' }));
          }
        }
        return Promise.reject(error);
      }
    );
  },
};
